import {
  AsyncPipe,
  NgIf,
} from '@angular/common';
import {
  Component,
  OnInit,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';
import { filter, map } from 'rxjs/operators';

import { HostWindowService, WidthCategory } from '../../../../../app/shared/host-window.service';
import { ThemedAuthNavMenuComponent } from '../../../../../app/shared/auth-nav-menu/themed-auth-nav-menu.component';
import { ThemedSearchNavbarComponent } from '../../../../../app/search-navbar/themed-search-navbar.component';
import { AppState, routerStateSelector } from '../../../../../app/app.reducer';
import { AuthService, LOGIN_ROUTE, LOGOUT_ROUTE } from '../../../../../app/core/auth/auth.service';
import { isAuthenticated, isAuthenticationLoading } from '../../../../../app/core/auth/selectors';
import { EPerson } from '../../../../../app/core/eperson/models/eperson.model';
import { isNotUndefined } from '../../../../../app/shared/empty.util';


/**
 * Represents the top header with social media icons and authentication for DSpace theme
 */
@Component({
  selector: 'ds-top-header',
  styleUrls: ['./top-header.component.scss'],
  templateUrl: './top-header.component.html',
  standalone: true,
  imports: [RouterLink, NgbDropdownModule, TranslateModule, AsyncPipe, NgIf, ThemedAuthNavMenuComponent, ThemedSearchNavbarComponent],
})
export class TopHeaderComponent implements OnInit {
  public isMobile$: Observable<boolean>;
  public isAuthenticated$: Observable<boolean>;
  public loading: Observable<boolean>;
  public user: Observable<EPerson>;
  public showAuth$: Observable<boolean>;
  public sub: Subscription;
  
  maxMobileWidth = WidthCategory.SM;

  constructor(
    protected windowService: HostWindowService,
    private store: Store<AppState>,
    private authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    this.isMobile$ = this.windowService.isUpTo(this.maxMobileWidth);
    
    // set isAuthenticated
    this.isAuthenticated$ = this.store.pipe(select(isAuthenticated));

    // set loading
    this.loading = this.store.pipe(select(isAuthenticationLoading));

    this.user = this.authService.getAuthenticatedUserFromStore();

    this.showAuth$ = this.store.pipe(
      select(routerStateSelector),
      filter((routerState: RouterReducerState) => isNotUndefined(routerState)),
      map((routerState: RouterReducerState) => {
        if (isNotUndefined(routerState) && isNotUndefined(routerState.state)) {
          return !routerState.state.url.includes(LOGIN_ROUTE) && !routerState.state.url.includes(LOGOUT_ROUTE);
        }
        return false;
      })
    );
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
